// EditorApp swallows Tab editor-wide; inside an open dialog (VideoModal / AppModal) it must work.
export const tabInDialog = (e) => !!e?.target?.closest?.(".pageModal, .app-modal");
